var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubtful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2391 14.0026L5.99977 14.005C5.72363 14.0051 5.49988 14.229 5.5 14.5052C5.50012 14.7813 5.72408 15.0051 6.00023 15.005L11.5002 15.0025L17.0002 15C17.2764 14.9999 17.5001 14.7759 17.5 14.4998C17.4999 14.2236 17.2759 13.9999 16.9998 14L15.7907 14.0005C15.7886 14.0004 15.7865 14.0002 15.7843 14H16.5C17 14 15.1786 13.9994 15.7843 14H11.5C11.4116 14.0009 11.3247 14.0018 11.2391 14.0026Z",
    fill: "#E0A510"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.68 8.64C13.68 9.43416 14.3258 10.08 15.12 10.08C15.9142 10.08 16.56 9.43416 16.56 8.64C16.56 7.84584 15.9142 7.2 15.12 7.2C14.3258 7.2 13.68 7.84584 13.68 8.64Z",
    fill: "#E0A510"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48 8.64C6.48 9.43416 7.12584 10.08 7.92 10.08C8.71416 10.08 9.36 9.43416 9.36 8.64C9.36 7.84584 8.71416 7.2 7.92 7.2C7.12584 7.2 6.48 7.84584 6.48 8.64Z",
    fill: "#E0A510"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.52C0 17.8721 5.16792 23.04 11.52 23.04C17.8721 23.04 23.04 17.8721 23.04 11.52C23.04 5.16792 17.8721 0 11.52 0C5.16792 0 0 5.16792 0 11.52ZM1.44 11.52C1.44 5.96184 5.96184 1.44 11.52 1.44C17.0782 1.44 21.6 5.96184 21.6 11.52C21.6 17.0782 17.0782 21.6 11.52 21.6C5.96184 21.6 1.44 17.0782 1.44 11.52Z",
    fill: "#E0A510"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubtful);
export default __webpack_public_path__ + "static/media/Doubtful.ffc8efa8b858042d789f1a11daf382aa.svg";
export { ForwardRef as ReactComponent };